import {ReactNode} from 'react'
import cn from 'clsx'

import './Tag.scss'
import {
  CheckCircleIcon,
  CheckCircleSecondIcon,
  ChatSecondIcon,
  ShieldChekIcon,
  BlackboardChartSecondIcon,
  RotateArrowSecondIcon,
  RequestSecondIcon,
  CloseCircleIcon,
  CloseCircleSecondIcon,
  FileBlankIcon,
} from 'common/components'

interface TagProps {
  children: ReactNode
  className?: string
  transparent?: boolean
  block?: boolean
  variant?: 'default' | 'round' | 'title'
  size?: 'normal' | 'large'
  color?:
    | 'default'
    | 'charcoal'
    | 'success'
    | 'danger'
    | 'warning'
    | 'turquoize'
    | 'green'
    | 'red'
    | 'grey'
  icon?:
    | 'check'
    | 'checkLarge'
    | 'message'
    | 'shield'
    | 'blackboard'
    | 'repeat'
    | 'request'
    | 'close'
    | 'closeLarge'
    | 'file'
  onClick?: () => void
}

const iconComponent = {
  check: CheckCircleIcon,
  checkLarge: CheckCircleSecondIcon,
  message: ChatSecondIcon,
  shield: ShieldChekIcon,
  blackboard: BlackboardChartSecondIcon,
  repeat: RotateArrowSecondIcon,
  request: RequestSecondIcon,
  close: CloseCircleIcon,
  closeLarge: CloseCircleSecondIcon,
  file: FileBlankIcon,
}

export default function Tag({
  children,
  className,
  transparent,
  block,
  size = 'normal',
  color = 'default',
  variant = 'default',
  icon,
  onClick,
}: TagProps) {
  const Icon = iconComponent[icon]
  const Component = onClick ? 'button' : 'div'

  return (
    <Component
      className={cn(
        className,
        `Tag Tag_size_${size} Tag_color_${color} Tag_variant_${variant}`,
        transparent && 'Tag_transparent',
        block && 'Tag_block',
        onClick && 'Tag_button'
      )}
      onClick={onClick}
    >
      <span className="Tag-Text">{children}</span>
      {Icon && <Icon className="Tag-Icon" />}
    </Component>
  )
}
